import ReactCountryFlag from 'react-country-flag';

import { Badge } from '@mantine/core';

import { JURISDICTIONS } from '@/constants';
import { Country } from '@/types';
import { TruncatingPill } from '../TruncatingPill';

interface CountryPillProps {
  country: Country | string;
}

/** Flag + alpha-2 code badge for a jurisdiction — the dense table form.
 * The full country name stays readable as the hover title. */
export function CountryPill({ country }: Readonly<CountryPillProps>) {
  if (typeof country !== 'string') {
    return <CountryBadge country={country} />;
  }
  const resolved = JURISDICTIONS.find((c) => c.name === country);
  // Unresolvable free-text jurisdiction — the plain name pill beats a
  // meaningless "XX" badge.
  return resolved ? <CountryBadge country={resolved} /> : <TruncatingPill label={country} />;
}

function CountryBadge({ country }: Readonly<{ country: Country }>) {
  return (
    <Badge
      size="xs"
      leftSection={<ReactCountryFlag countryCode={country.alpha2code} svg />}
      color="var(--mantine-color-yellow-6)"
      variant="light"
      title={country.name}
    >
      {country.alpha2code.toUpperCase()}
    </Badge>
  );
}
